import React from "react";
import Carousel from "react-material-ui-carousel";
import ServiceSliderItem from "./ServiceSliderItem";
import { Link } from "react-router-dom";
import {
  Container,
  Typography,
  Button,
  makeStyles,
  Grid,
} from "@material-ui/core";
import { serviceSliderImages } from "../data";
import "./Slider.css";

const useStyles = makeStyles((theme) => ({
  root: {
    textAlign: "center",
    marginTop: "5.8rem",
    marginBottom: "5.8rem",
  },
  text: {
    padding: "0 10%",
    marginTop: "2.8rem",
    [theme.breakpoints.down("sm")]: {
      padding: "0 5%",
    },
  },
  link: { textDecoration: "none" },
  btnSlider: {
    padding: "1rem 5rem",
    textTransform: "none",
    marginTop: "3rem",
    backgroundColor: "#026FC2",
    color: "#ffffff",
    "&:hover": {
      backgroundColor: "#0252c2",
      color: "#ffffff",
    },
  },
}));

const ServiceSlider = ({ header, subHeader }) => {
  const classes = useStyles();
  return (
    <Container maxWidth="lg" className={`${classes.root} serviceSlider`}>
      <Grid container spacing={3}>
        <Grid item xs={12} md={5}>
          <Carousel>
            {serviceSliderImages.map((item, index) => {
              return (
                <ServiceSliderItem
                  title={item.title}
                  key={index}
                  imageURL={item.image}
                />
              );
            })}
          </Carousel>
        </Grid>
        <Grid item xs={12} md={7}>
          <Typography variant="h1" color="primary" className={classes.text}>
            {header}
          </Typography>
          {subHeader && (
            <Typography variant="h3" color="primary" className={classes.text}>
              {subHeader}
            </Typography>
          )}
          <Link to="/blog">
            <Button
              className={classes.btnSlider}
              variant="outlined"
              color="primary"
            >
              Read More
            </Button>
          </Link>
        </Grid>
      </Grid>
    </Container>
  );
};

export default ServiceSlider;
